import { render, staticRenderFns } from "./Newsletter.vue?vue&type=template&id=1aff0738&"
import script from "./Newsletter.vue?vue&type=script&lang=js&"
export * from "./Newsletter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormNewsletterModern: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Form/NewsletterModern/index.vue').default})
